import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function Steps() {
  const steps = [{
    num: '1',
    text: 'Descarga el material inmediatamente y lee el Protocolo de 7 Segundos (toma menos de 10 minutos).'
  }, {
    num: '2',
    text: 'Aplica la técnica del "Espejo Emocional" en el próximo berrinche.'
  }, {
    num: '3',
    text: 'Observa cómo, en menos de una semana, la tensión en tu casa disminuye y la cooperación aumenta.'
  }];
  return <section className="py-20 px-4 bg-terracotta text-cream" data-id="element-224">
      <div className="max-w-4xl mx-auto" data-id="element-225">
        <FadeIn data-id="element-226">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-16 text-cream" data-id="element-227">
            ¿Cómo funciona?
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-228">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-10 left-[15%] right-[15%] h-0.5 bg-terracotta-400 z-0" data-id="element-229"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative z-10 text-center" data-id="element-230">
              <div className="w-20 h-20 mx-auto bg-gold text-terracotta-900 text-3xl font-bold rounded-full flex items-center justify-center mb-6 shadow-lg border-4 border-terracotta" data-id="element-231">
                {step.num}
              </div>
              <p className="text-lg text-terracotta-100 leading-relaxed px-4" data-id="element-232">
                {step.text}
              </p>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} className="mt-20 bg-terracotta-800/50 p-8 rounded-3xl border border-terracotta-600 text-center" data-id="element-233">
          <h3 className="text-2xl font-bold mb-4 font-heading text-gold-300" data-id="element-234">
            La Promesa
          </h3>
          <p className="text-xl text-cream-100 leading-relaxed" data-id="element-235">
            En los próximos 7 días, notarás que el volumen de los gritos en tu
            casa bajará un 50%. No porque tus hijos se porten perfecto
            mágicamente, sino porque tú habrás recuperado el control del
            termostato emocional de tu hogar.
          </p>
        </FadeIn>
      </div>
    </section>;
}